<script lang="ts">
  import type {
    Products_ItemChoice,
    Products_ItemChoiceValue,
  } from "scripts/products/types";
  import { numToJPY } from "scripts/utils/price_utils";
  import { linebreakToBr } from "scripts/utils/utils";
  import InvalidMessage from "scripts/global_components/input/InvalidMessage.svelte";
  import type {
    InvalidMessages,
    MessageContent,
    OrderItemChoiceValue,
    SelectedValues,
    TypeOrderItem,
  } from "../types";

  export let itemChoices: Products_ItemChoice[];
  export let selectedValues: SelectedValues;

  export let invalidMessages: InvalidMessages;

  const defaultInvalidMessage = {
    message: "",
    isValid: true,
  };

  const defaultSelectedValue: OrderItemChoiceValue = {
    id: null,
    code: "",
    branch: "",
    tax_rate: 0.1,
    additional_fee: 0,
    additional_fee_with_tax: 0,
    spec_text: "",
    free_amount: 0,
  };

  const updateItemChoices = (itemChoices: Products_ItemChoice[]) => {
    if (itemChoices.length && !invalidMessages && !selectedValues) {
      if (!invalidMessages) invalidMessages = {};
      if (!selectedValues) selectedValues = {};
      itemChoices.forEach((itemChoice) => {
        invalidMessages[itemChoice.id] = { ...defaultInvalidMessage };
        selectedValues[itemChoice.id] = { ...defaultSelectedValue };
      });
    }
  };

  const choiceCardButtonClick = (
    e,
    choice: Products_ItemChoice,
    choicevalue: Products_ItemChoiceValue,
  ) => {
    selectedValues[choice.id] = {
      id: choicevalue.id,
      code: choicevalue.code,
      branch: choicevalue.branch,
      tax_rate: choicevalue.tax_rate,
      additional_fee: choicevalue.additional_fee,
      additional_fee_with_tax: choicevalue.additional_fee_with_tax,
      spec_text: choicevalue.spec_text,
      free_amount: choicevalue.free_amount,
    };
    const cardEls: HTMLElement[] = Array.from(
      document
        .querySelector(`#choice-${choice.id}`)
        .querySelectorAll(".choiceCard"),
    );
    cardEls.forEach((cardEl) => {
      cardEl.classList.remove("selected");
      if (cardEl.id == `choiceCard-${choicevalue.id}`) {
        cardEl.classList.add("selected");
      }
    });
  };

  const onSelectChange = (e, choice: Products_ItemChoice) => {
    const choicevalue = choice.itemchoicevalue_set.find(
      (cv) => cv.id == Number(e.target.value),
    ) || { ...defaultSelectedValue };
    selectedValues[choice.id] = {
      id: choicevalue.id,
      code: choicevalue.code,
      branch: choicevalue.branch,
      tax_rate: choicevalue.tax_rate,
      additional_fee: choicevalue.additional_fee,
      additional_fee_with_tax: choicevalue.additional_fee_with_tax,
      spec_text: choicevalue.spec_text,
      free_amount: choicevalue.free_amount,
    };
  };

  const checkInput = (
    e,
    choice: Products_ItemChoice,
    choicevalue: Products_ItemChoiceValue,
  ) => {
    console.log(choicevalue);

    if (e.target.checked) {
      selectedValues[choice.id] = {
        id: choicevalue.id,
        code: choicevalue.code,
        branch: choicevalue.branch,
        tax_rate: choicevalue.tax_rate,
        additional_fee: choicevalue.additional_fee,
        additional_fee_with_tax: choicevalue.additional_fee_with_tax,
        spec_text: choicevalue.spec_text,
        free_amount: choicevalue.free_amount,
      };
    } else selectedValues[choice.id] = { ...defaultSelectedValue };
    const els: HTMLInputElement[] = Array.from(
      document
        .querySelector(`#choice-${choice.id}`)
        .querySelectorAll(".form-check-input"),
    );
    els.forEach((element) => {
      if (element.id == `choiceValue-${choicevalue.id}`) {
        element.checked = e.target.checked;
      } else {
        element.checked = false;
      }
    });
  };

  const standardValidation = (
    itemChoice: Products_ItemChoice,
  ): MessageContent => {
    let message = "";
    let isValid = true;
    if (
      itemChoice.necessary &&
      !selectedValues[itemChoice.id].id &&
      !selectedValues[itemChoice.id].spec_text
    ) {
      message = "この項目を入力してください";
      isValid = false;
    }
    return {
      message,
      isValid,
    };
  };

  export const validate = (selectedValues: SelectedValues): InvalidMessages => {
    let result: InvalidMessages = {};
    if (selectedValues) {
      Object.entries(selectedValues).forEach(
        ([choiceId, orderItemChoiceValue]) => {
          const itemChoice = itemChoices.find(
            (choice) => choice.id == Number(choiceId),
          );

          const resultOfStandard = standardValidation(itemChoice);
          // console.log("valid", choiceId, itemChoice, result);
          result[choiceId] = resultOfStandard;
        },
      );
    }
    invalidMessages = result;
    return result;
  };

  $: updateItemChoices(itemChoices);
  $: validate(selectedValues);
  // $: console.log("itemChoices", itemChoices);
  // $: console.log("selectedValues", selectedValues);
  // $: console.log("invalidMessages", invalidMessages);
</script>

{#if selectedValues}
  <div class="row">
    <div class="col-12">
      {#each itemChoices as choice}
        {#if choice.branch_type == "select"}
          <div class="px-1 py-3">
            <h6 class="font-weight-bolder">・{choice.choice_name}</h6>
            <div class="row px-3">
              <div class="col-12">
                <select
                  name="itemChoice-{choice.id}"
                  class="select form-select"
                  id="itemChoice-{choice.id}"
                  required={choice.necessary}
                  bind:value={selectedValues[choice.id].id}
                  on:change={(e) => {
                    onSelectChange(e, choice);
                  }}
                >
                  <option selected value={null}>-------------</option>
                  {#each choice.itemchoicevalue_set as choicevalue}
                    <option value={choicevalue.id}>
                      {choicevalue.branch} - {choicevalue.additional_fee_with_tax}円(税込)
                    </option>
                  {/each}
                </select>
              </div>
            </div>
            <div class="px-3">
              <InvalidMessage
                bind:message={invalidMessages[choice.id].message}
                bind:is_valid={invalidMessages[choice.id].isValid}
              />
            </div>
          </div>
        {:else if choice.branch_type == "check"}
          <div class="px-1 py-3">
            <h6 class="font-weight-bolder">・{choice.choice_name}</h6>
            <div class="row px-3" id="choice-{choice.id}">
              {#each choice.itemchoicevalue_set as choicevalue}
                <div class="col-6">
                  <div class="form-group horizontal-checkbox px-1">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="choiceValue-{choicevalue.id}"
                      value={choicevalue.id}
                      on:change={(e) => checkInput(e, choice, choicevalue)}
                    />
                    <label
                      class="form-check-label"
                      for="choiceValue-{choicevalue.id}"
                      >{choicevalue.branch} - {choicevalue.additional_fee_with_tax}円(税込)</label
                    >
                  </div>
                </div>
              {/each}
            </div>
            <div class="px-3">
              <InvalidMessage
                bind:message={invalidMessages[choice.id].message}
                bind:is_valid={invalidMessages[choice.id].isValid}
              />
            </div>
          </div>
        {:else if choice.branch_type == "free"}
          <div class="px-1 py-3">
            <h6 class="font-weight-bolder">・{choice.choice_name}</h6>
            <div class="row px-3">
              <div class="col-12">
                <textarea
                  class="form-control"
                  id="itemChoice-{choice.id}"
                  rows="3"
                  maxlength="126"
                  required={choice.necessary}
                  bind:value={selectedValues[choice.id].spec_text}
                />
              </div>
            </div>
            <div class="px-3">
              <InvalidMessage
                bind:message={invalidMessages[choice.id].message}
                bind:is_valid={invalidMessages[choice.id].isValid}
              />
            </div>
          </div>
        {:else if choice.branch_type == "i"}
          <div class="px-1 py-3">
            <h6 class="font-weight-bolder">・{choice.choice_name}</h6>
            <div
              class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4 px-3"
              id="choice-{choice.id}"
            >
              {#each choice.itemchoicevalue_set as choicevalue}
                <div class="col">
                  <div
                    class="card choiceCard p-1"
                    id="choiceCard-{choicevalue.id}"
                  >
                    <button
                      on:click={(e) =>
                        choiceCardButtonClick(e, choice, choicevalue)}
                    >
                      <div
                        class="card-header p-2 font-weight-bold"
                        style="font-size: 0.9rem;"
                      >
                        {choicevalue.branch}
                      </div>
                      <div class="card-body text-start p-3">
                        <div class="card-text" style="font-size: 0.8rem;">
                          <div class="row">
                            <div class="col-12">
                              <span class="font-weight-bolder"
                                >追加料金 : {`${numToJPY(
                                  choicevalue.additional_fee_with_tax,
                                )}円(税込)`}
                              </span>
                            </div>
                            <div class="col-12">
                              在庫数 : {choicevalue.free_amount} 個
                            </div>
                          </div>
                          {#if choicevalue.spec_text}
                            <div class="row">
                              <div class="col-12">
                                仕様 : <span class="">
                                  {@html linebreakToBr(choicevalue.spec_text)}
                                </span>
                              </div>
                            </div>
                          {/if}
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
              {/each}
            </div>
            <div class="px-3">
              <InvalidMessage
                bind:message={invalidMessages[choice.id].message}
                bind:is_valid={invalidMessages[choice.id].isValid}
              />
            </div>
          </div>
        {/if}
      {/each}
    </div>
  </div>
{/if}

<style>
  .choiceCard {
    border: 0.5px solid #aaa;
  }
  .choiceCard button {
    border: 0;
    background-color: #fff;
    padding: 0;
  }
  .choiceCard:global(.selected) {
    border: 2px solid #1266f1;
  }
</style>
